export const useAmplitude = () => useNuxtApp().$amplitude;
